import { render, staticRenderFns } from "./PinIcon.vue?vue&type=template&id=21939f8e&scoped=true"
import script from "./PinIcon.vue?vue&type=script&lang=js"
export * from "./PinIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21939f8e",
  null
  
)

export default component.exports